import { isSameDay } from "date-fns";
var TODAY_STYLE = {
  fontWeight: 700,
  boxShadow: "inset 0 0 0 1px var(--sds-border-brand-default)"
};

/**
 * Builds a Mantine dayStyle resolver that rings today's date, or undefined when
 * highlighting is disabled. The selected day keeps its own styling.
 */
export function buildTodayDayStyle(enabled) {
  if (!enabled) return undefined;
  var today = new Date();
  return function (date, modifiers) {
    return !modifiers.selected && isSameDay(date, today) ? TODAY_STYLE : {};
  };
}